// // import React, { useEffect, useMemo, useState } from 'react';
// // import Select from 'react-select';
// // import { useTranslation } from 'react-i18next';
// // import { useNavigate } from 'react-router-dom';

// // import Loading from '@components/Shared/Loader/Loading';
// // import { Card, CardFooter, CardHeader } from '@components/card/card';

// // import { useAppDispatch, useAppSelector } from '@store/hooks';
// // import { initReport, getReportPagedData, selectReport, setReportRequest } from '@store/DynamicSlice/reportTableSlice';

// // import ReportExportExcelModal, { type ExportColumn } from '@Helper/ReportPaged/ReportExportExcelModal';
// // import ReportPagination from '@Helper/ReportPaged/ReportPagination';

// // import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';

// // /** =========================
// //  * REQUEST SHAPE
// //  * ========================= */
// // type TaxDeclarationRequestDto = {
// //   pageIndex?: number;
// //   pageSize?: number;

// //   // ✅ modern keys
// //   fromDate?: string | null;
// //   toDate?: string | null;
// //   branchId?: string | null;
// //   status?: string | null;
// //   taxType?: string | null;

// //   // ✅ legacy keys (to be safe with API)
// //   froM_DATE?: string | null;
// //   tO_DATE?: string | null;
// //   brancH_ID?: string | null;
// //   taX_TYPE?: string | null;
// // };

// // /** =========================
// //  * RESPONSE SHAPE (Array items)
// //  * ========================= */
// // type RowDto = {
// //   jE_HEADER_ID: string | null;
// //   gL_DATE: string | null;

// //   referencE_ID: string | null;
// //   code: string | null;

// //   taX_TYPE: string | null;

// //   name: string | null;
// //   namE2: string | null;

// //   linE_DESCRIPTION: string | null;
// //   brancH_NAME: string | null;

// //   entereD_DR: number;
// //   entereD_CR: number;
// //   cumulativE_BALANCE: number;
// // };

// // const REPORT_KEY = 'RPT_TaxDeclarationStatement';
// // const ENDPOINT = 'FinReports/GetTaxDeclarationStatement';

// // const safe = (v: any, fallback = '—') => (v === null || v === undefined || v === '' ? fallback : String(v));

// // const formatNumber = (num: number | null | undefined, digits: number = 2) => {
// //   if (num === null || num === undefined) return '0.00';
// //   return new Intl.NumberFormat('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(
// //     num || 0
// //   );
// // };

// // const isoOrNull = (d: any) => {
// //   if (!d) return null;
// //   if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) return `${d}T00:00:00.000Z`;
// //   if (d instanceof Date) return d.toISOString();
// //   return null;
// // };

// // const cleanNulls = <T extends Record<string, any>>(obj: T): Partial<T> => {
// //   const out: any = {};
// //   for (const [k, v] of Object.entries(obj)) {
// //     if (v === null || v === undefined || v === '') continue;
// //     out[k] = v; // ✅ يحافظ على 0 و false
// //   }
// //   return out;
// // };

// // const getOptId = (opt: any): string | null => {
// //   const v = opt?.value ?? opt?.id ?? opt?.ID ?? opt?.key ?? null;
// //   return v ? String(v) : null;
// // };

// // const getCodePrefix = (code?: string | null) => {
// //   const c = (code ?? '').trim().toUpperCase();
// //   if (!c) return null;
// //   const m = c.match(/^[A-Z]+/);
// //   return m?.[0] ?? null;
// // };

// // /**
// //  * ✅ عدّل الروابط حسب الـ Routes عندك
// //  * INV: Invoice (AP Invoice غالبًا)
// //  * CASH: Cash Transfer
// //  * MOI/MOR/MOV: مخزني
// //  */
// // const buildDocLink = (code?: string | null, id?: string | null) => {
// //   if (!id) return null;
// //   const p = getCodePrefix(code);

// //   switch (p) {
// //     case 'INV':
// //       return `/AP/ApInvoices/${id}/UpdateApInvoices`; // ✅ عدّل حسب Route عندكم
// //     default:
// //       return `/finance/documents/${id}`; // fallback
// //   }
// // };

// // const TaxDeclarationStatement_Paged: React.FC = () => {
// //   const { t, i18n } = useTranslation();
// //   const isAr = i18n.language !== 'en';

// //   const dispatch = useAppDispatch();
// //   const navigate = useNavigate();

// //   // ===== Branch options
// //   const branchHook = useGetOperatingUnitWithPermission() as any;
// //   const OptionsBranches = branchHook?.OperatingUnitOptions ?? branchHook?.OptionsBranches ?? [];
// //   const loadingBranches = branchHook?.loading ?? false;

// //   // ===== Filters
// //   const [branchFilter, setBranchFilter] = useState<any>(null);
// //   const [fromDate, setFromDate] = useState<any>(null);
// //   const [toDate, setToDate] = useState<any>(null);

// //   const taxTypeOptions = useMemo(
// //     () => [
// //       { value: null, label: isAr ? 'الكل' : 'All' },
// //       { value: 'Purchase', label: isAr ? 'مشتريات' : 'Purchase' },
// //       { value: 'Sales', label: isAr ? 'مبيعات' : 'Sales' }
// //     ],
// //     [isAr]
// //   );
// //   const [taxType, setTaxType] = useState<any>(taxTypeOptions[0]);

// //   const statusOptions = useMemo(
// //     () => [
// //       { value: null, label: isAr ? 'الكل' : 'All' },
// //       { value: 'P', label: isAr ? 'مرحل' : 'Posted' },
// //       { value: 'U', label: isAr ? 'غير مرحل' : 'Unposted' }
// //     ],
// //     [isAr]
// //   );
// //   const [status, setStatus] = useState<any>(statusOptions[0]);

// //   const [showExport, setShowExport] = useState(false);

// //   // ===== Report state
// //   const report = useAppSelector(s => selectReport(s as any, REPORT_KEY));
// //   const items = (report?.items ?? []) as RowDto[];
// //   const meta = report?.meta ?? null;
// //   const loading = report?.loading ?? false;
// //   const error = report?.error ?? null;

// //   useEffect(() => {
// //     const initialRequest: TaxDeclarationRequestDto = {
// //       pageIndex: 0,
// //       pageSize: 50
// //     };

// //     dispatch(
// //       initReport({
// //         reportKey: REPORT_KEY,
// //         endpoint: ENDPOINT,
// //         initialRequest
// //       })
// //     );
// //   }, [dispatch]);

// //   const openDoc = (code?: string | null, id?: string | null) => {
// //     const url = buildDocLink(code, id);
// //     if (!url) return;
// //     navigate(url);
// //   };

// //   const applyFilters = () => {
// //     const branchId = getOptId(branchFilter);
// //     const fd = isoOrNull(fromDate);
// //     const td = isoOrNull(toDate);

// //     const prevReq = (((report as any)?.request ?? {}) as TaxDeclarationRequestDto) || {};

// //     const nextReq: TaxDeclarationRequestDto = {
// //       ...prevReq,
// //       pageIndex: 0,
// //       pageSize: prevReq.pageSize ?? 50,

// //       // modern
// //       fromDate: fd,
// //       toDate: td,
// //       branchId,
// //       taxType: taxType?.value ?? null,
// //       status: status?.value ?? null,

// //       // legacy duplicates (to be safe)
// //       froM_DATE: fd,
// //       tO_DATE: td,
// //       brancH_ID: branchId,
// //       taX_TYPE: taxType?.value ?? null
// //     };

// //     dispatch(setReportRequest({ reportKey: REPORT_KEY, request: cleanNulls(nextReq) as any }));
// //     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
// //   };

// //   const clearFilters = () => {
// //     setBranchFilter(null);
// //     setFromDate(null);
// //     setToDate(null);
// //     setTaxType(taxTypeOptions[0]);
// //     setStatus(statusOptions[0]);

// //     const resetReq: TaxDeclarationRequestDto = {
// //       pageIndex: 0,
// //       pageSize: 50
// //     };

// //     dispatch(setReportRequest({ reportKey: REPORT_KEY, request: resetReq as any }));
// //   };

// //   // Totals Cards Component - بنفس التصميم المطلوب
// //   const TotalsCards = () => {
// //     // if (!meta || !branchFilter) return null;
// //     if (!meta) return null;

// //     return (
// //       <div className='row g-3 mb-4'>
// //         {/* رصيد افتتاحي */}
// //         <div className='col-lg-3 col-md-6'>
// //           <Card className='bg-primary bg-opacity-10 border-0 shadow-sm h-100'>
// //             <div className='card-body d-flex align-items-center'>
// //               <div className='p-3 me-3'>
// //                 <i className='fas fa-scale-balanced text-primary fa-xl'></i>
// //               </div>
// //               <div>
// //                 <h6 className='text-primary fw-bold mb-1'>{isAr ? 'الرصيد الافتتاحي' : 'Opening Balance'}</h6>
// //                 <h4 className='mb-0 fw-bold'>{formatNumber(meta.openingBalance)}</h4>
// //               </div>
// //             </div>
// //           </Card>
// //         </div>

// //         {/* إجمالي الضريبة المدينة */}
// //         <div className='col-lg-3 col-md-6'>
// //           <Card className='bg-success bg-opacity-10 border-0 shadow-sm h-100'>
// //             <div className='card-body d-flex align-items-center'>
// //               <div className='p-3 me-3'>
// //                 <i className='fas fa-arrow-up text-success fa-xl'></i>
// //               </div>
// //               <div>
// //                 <h6 className='text-success fw-bold mb-1'>{isAr ? 'إجمالي ضريبة مدين' : 'Total Tax Debit'}</h6>
// //                 <h4 className='mb-0 fw-bold'>{formatNumber(meta.totalTaxDr)}</h4>
// //               </div>
// //             </div>
// //           </Card>
// //         </div>

// //         {/* إجمالي الضريبة الدائنة */}
// //         <div className='col-lg-3 col-md-6'>
// //           <Card className='bg-danger bg-opacity-10 border-0 shadow-sm h-100'>
// //             <div className='card-body d-flex align-items-center'>
// //               <div className='p-3 me-3'>
// //                 <i className='fas fa-arrow-down text-danger fa-xl'></i>
// //               </div>
// //               <div>
// //                 <h6 className='text-danger fw-bold mb-1'>{isAr ? 'إجمالي ضريبة دائن' : 'Total Tax Credit'}</h6>
// //                 <h4 className='mb-0 fw-bold'>{formatNumber(meta.totalTaxCr)}</h4>
// //               </div>
// //             </div>
// //           </Card>
// //         </div>

// //         {/* صافي الضريبة المستحقة */}
// //         <div className='col-lg-3 col-md-6'>
// //           <Card className='bg-warning bg-opacity-10 border-0 shadow-sm h-100'>
// //             <div className='card-body d-flex align-items-center'>
// //               <div className='p-3 me-3'>
// //                 <i className='fas fa-calculator text-warning fa-xl'></i>
// //               </div>
// //               <div>
// //                 <h6 className='text-warning fw-bold mb-1'>{isAr ? 'صافي الضريبة ' : 'Net Tax Payable'}</h6>
// //                 <h4 className='mb-0 fw-bold'>{formatNumber(meta.netTaxPayable)}</h4>
// //               </div>
// //             </div>
// //           </Card>
// //         </div>
// //       </div>
// //     );
// //   };

// //   const exportColumns: ExportColumn<RowDto>[] = [
// //     { headerAr: 'التاريخ', headerEn: 'GL Date', value: r => (r.gL_DATE ? r.gL_DATE.split('T')[0] : '') },
// //     { headerAr: 'الفرع', headerEn: 'Branch', value: r => r.brancH_NAME || '' },
// //     { headerAr: 'نوع الضريبة', headerEn: 'Tax Type', value: r => r.taX_TYPE || '' },
// //     { headerAr: 'الكود', headerEn: 'Code', value: r => r.code || '' },
// //     { headerAr: 'وصف السطر', headerEn: 'Line Desc', value: r => r.linE_DESCRIPTION || '' },
// //     { headerAr: 'مدين', headerEn: 'Debit', value: r => r.entereD_DR || 0 },
// //     { headerAr: 'دائن', headerEn: 'Credit', value: r => r.entereD_CR || 0 },
// //     { headerAr: 'الرصيد', headerEn: 'Balance', value: r => r.cumulativE_BALANCE || 0 },
// //     { headerAr: 'الوصف', headerEn: 'Description', value: r => (isAr ? r.namE2 || r.name : r.name || r.namE2) || '' }
// //   ];

// //   return (
// //     <>
// //       <CardHeader className='mb-3'>
// //         <div className='row g-2 align-items-center mb-2'>
// //           {/* Branch */}
// //           <div className='col-lg-4'>
// //             <div className='input-group'>
// //               <span className='input-group-text fw-bold'>
// //                 <i className='fas fa-store text-primary'></i>
// //               </span>
// //               <Select
// //                 isLoading={loadingBranches}
// //                 value={branchFilter}
// //                 onChange={setBranchFilter}
// //                 options={OptionsBranches}
// //                 placeholder={isAr ? 'الفرع' : 'Branch'}
// //                 isClearable
// //                 isSearchable
// //                 className='flex-grow-1'
// //                 classNamePrefix='react-select'
// //                 menuPortalTarget={document.body}
// //                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
// //               />
// //             </div>
// //           </div>

// //           {/* Tax Type */}
// //           <div className='col-lg-3'>
// //             <Select
// //               value={taxType}
// //               onChange={setTaxType}
// //               options={taxTypeOptions}
// //               placeholder={isAr ? 'نوع الضريبة' : 'Tax Type'}
// //               isSearchable
// //               classNamePrefix='react-select'
// //               menuPortalTarget={document.body}
// //               styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
// //             />
// //           </div>

// //           {/* Status */}
// //           <div className='col-lg-3'>
// //             <Select
// //               value={status}
// //               onChange={setStatus}
// //               options={statusOptions}
// //               placeholder={isAr ? 'الحالة' : 'Status'}
// //               isSearchable
// //               classNamePrefix='react-select'
// //               menuPortalTarget={document.body}
// //               styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
// //             />
// //           </div>

// //           {/* Buttons */}
// //           <div className='col-lg-2 text-end'>
// //             <button
// //               className='btn btn-outline-secondary me-2'
// //               type='button'
// //               onClick={clearFilters}
// //               title={t('ClearFilters')}
// //             >
// //               <i className='fas fa-times fa-fw'></i>
// //             </button>

// //             <button className='btn btn-theme' type='button' onClick={applyFilters} title={t('ApplyFilters')}>
// //               <i className='fas fa-filter fa-fw'></i>
// //             </button>
// //           </div>
// //         </div>

// //         <div className='row g-2 align-items-center'>
// //           {/* From Date */}
// //           <div className='col-lg-2'>
// //             <div className='input-group'>
// //               <span className='input-group-text fw-bold'>
// //                 <i className='fas fa-calendar'></i>
// //               </span>
// //               <input
// //                 type='date'
// //                 className='form-control'
// //                 value={fromDate || ''}
// //                 onChange={e => setFromDate(e.target.value)}
// //                 placeholder={isAr ? 'من تاريخ' : 'From Date'}
// //               />
// //             </div>
// //           </div>

// //           {/* To Date */}
// //           <div className='col-lg-2'>
// //             <div className='input-group'>
// //               <span className='input-group-text fw-bold'>
// //                 <i className='fas fa-calendar'></i>
// //               </span>
// //               <input
// //                 type='date'
// //                 className='form-control'
// //                 value={toDate || ''}
// //                 onChange={e => setToDate(e.target.value)}
// //                 min={fromDate || undefined}
// //                 placeholder={isAr ? 'إلى تاريخ' : 'To Date'}
// //               />
// //             </div>
// //           </div>

// //           {/* Export */}
// //           <div className='col-lg-8 text-end'>
// //             <button
// //               className='btn btn-outline-success'
// //               type='button'
// //               onClick={() => setShowExport(true)}
// //               title={t('Export')}
// //               disabled={loading || items.length === 0}
// //             >
// //               <i className='fas fa-file-excel fa-fw'></i>
// //             </button>
// //           </div>
// //         </div>
// //       </CardHeader>

// //       {/* كروت الإجماليات - بنفس التصميم المطلوب */}
// //       <TotalsCards />

// //       <Card className='mb-4'>
// //         <Loading loading={loading} error={error}>
// //           <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
// //             <table className='table table-hover table-bordered mb-0'>
// //               <thead className='sticky-top align-middle' style={{ top: 0, zIndex: 10 }}>
// //                 {/* Group header (مشابه لفكرة جدول المورد) */}
// //                 <tr className='bg-theme bg-opacity-35 text-center' style={{ backdropFilter: 'blur(20px)' }}>
// //                   <th className='small text-primary' colSpan={6}>
// //                     {isAr ? 'تفاصيل البيان' : 'Statement Info'}
// //                   </th>
// //                   <th className='small text-success' colSpan={3}>
// //                     {isAr ? 'المبالغ' : 'Amounts'}
// //                   </th>
// //                 </tr>

// //                 <tr className='bg-theme bg-opacity-25 text-center' style={{ backdropFilter: 'blur(20px)' }}>
// //                   <th className='small' style={{ minWidth: 105 }}>
// //                     {isAr ? 'التاريخ' : 'Date'}
// //                   </th>
// //                   <th className='small' style={{ minWidth: 140 }}>
// //                     {isAr ? 'الفرع' : 'Branch'}
// //                   </th>
// //                   <th className='small' style={{ minWidth: 100 }}>
// //                     {isAr ? 'النوع' : 'Type'}
// //                   </th>
// //                   <th className='small' style={{ minWidth: 130 }}>
// //                     {isAr ? 'الكود' : 'Code'}
// //                   </th>
// //                   <th className='small' style={{ minWidth: 120 }}>
// //                     {isAr ? 'وصف السطر' : 'Line Desc'}
// //                   </th>
// //                   <th className='small' style={{ minWidth: 360 }}>
// //                     {isAr ? 'الوصف' : 'Description'}
// //                   </th>

// //                   <th className='small text-end' style={{ minWidth: 110 }}>
// //                     {isAr ? 'مدين' : 'Debit'}
// //                   </th>
// //                   <th className='small text-end' style={{ minWidth: 110 }}>
// //                     {isAr ? 'دائن' : 'Credit'}
// //                   </th>
// //                   <th className='small text-end' style={{ minWidth: 130 }}>
// //                     {isAr ? 'الرصيد' : 'Balance'}
// //                   </th>
// //                 </tr>
// //               </thead>

// //               <tbody>
// //                 {!loading && items.length > 0 ? (
// //                   items.map((r, idx) => {
// //                     const desc = (isAr ? r.namE2 || r.name : r.name || r.namE2) || '';
// //                     const isOpening = !r.jE_HEADER_ID && !r.gL_DATE;

// //                     return (
// //                       <tr
// //                         key={`${r.jE_HEADER_ID || 'OB'}-${idx}`}
// //                         className={`align-middle ${isOpening ? 'table-light fw-bold' : ''}`}
// //                       >
// //                         <td className='text-center'>
// //                           {r.gL_DATE ? r.gL_DATE.split('T')[0] : isAr ? 'افتتاحي' : 'Opening'}
// //                         </td>

// //                         <td className='text-start'>{safe(r.brancH_NAME)}</td>

// //                         <td className='text-center'>
// //                           <span className='badge bg-info bg-opacity-10 border border-info text-info'>
// //                             {safe(r.taX_TYPE, isAr ? '—' : '—')}
// //                           </span>
// //                         </td>

// //                         <td className='text-center'>
// //                           {r.code && r.referencE_ID ? (
// //                             <button
// //                               type='button'
// //                               className='btn btn-link p-0 fw-bold text-primary text-decoration-none'
// //                               onClick={() => openDoc(r.code, r.referencE_ID)}
// //                               title={isAr ? 'فتح المستند' : 'Open document'}
// //                             >
// //                               {r.code}
// //                             </button>
// //                           ) : (
// //                             <span className='text-muted'>{safe(r.code)}</span>
// //                           )}
// //                         </td>

// //                         <td className='text-start'>{safe(r.linE_DESCRIPTION)}</td>

// //                         <td className='text-start'>
// //                           <span className={desc ? '' : 'text-muted fst-italic'}>
// //                             {safe(desc, isAr ? 'لا يوجد وصف' : 'No description')}
// //                           </span>
// //                         </td>

// //                         <td className='text-end'>
// //                           {r.entereD_DR > 0 ? (
// //                             <span className='fw-bold text-success'>{formatNumber(r.entereD_DR)}</span>
// //                           ) : (
// //                             <span className='text-muted'>—</span>
// //                           )}
// //                         </td>

// //                         <td className='text-end'>
// //                           {r.entereD_CR > 0 ? (
// //                             <span className='fw-bold text-danger'>{formatNumber(r.entereD_CR)}</span>
// //                           ) : (
// //                             <span className='text-muted'>—</span>
// //                           )}
// //                         </td>

// //                         <td className='text-end'>
// //                           <span className={`fw-bold ${r.cumulativE_BALANCE < 0 ? 'text-danger' : 'text-success'}`}>
// //                             {formatNumber(r.cumulativE_BALANCE)}
// //                           </span>
// //                         </td>
// //                       </tr>
// //                     );
// //                   })
// //                 ) : !loading ? (
// //                   <tr>
// //                     <td colSpan={9} className='text-center py-5'>
// //                       <div className='text-muted'>
// //                         <i className='fas fa-file-invoice fa-3x mb-3 opacity-50'></i>
// //                         <h6>{t('NoData')}</h6>
// //                       </div>
// //                     </td>
// //                   </tr>
// //                 ) : null}
// //               </tbody>
// //             </table>
// //           </div>
// //         </Loading>

// //         <CardFooter>
// //           <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
// //             <ReportPagination reportKey={REPORT_KEY} maxVisiblePages={3} showItemsPerPage={true} />

// //             {!loading && items.length > 0 && (
// //               <div className='text-muted small'>
// //                 <i className='fas fa-info-circle me-1'></i>
// //                 {isAr ? 'عرض' : 'Showing'} {items.length} {isAr ? 'من' : 'of'} {meta?.totalRows || 0}{' '}
// //                 {isAr ? 'سجل' : 'records'}
// //               </div>
// //             )}
// //           </div>
// //         </CardFooter>
// //       </Card>

// //       <ReportExportExcelModal
// //         show={showExport}
// //         onHide={() => setShowExport(false)}
// //         reportKey={REPORT_KEY}
// //         endpoint={ENDPOINT}
// //         columns={exportColumns}
// //         exportPageSize={4000}
// //         sheetName={({ isAr }) => (isAr ? 'بيان إقرار ضريبي' : 'Tax Declaration Statement')}
// //         fileName={({ reportKey }) => `${reportKey}_${new Date().toISOString().slice(0, 10)}.xlsx`}
// //       />
// //     </>
// //   );
// // };

// // export default TaxDeclarationStatement_Paged;

// import React, { useEffect, useMemo, useState } from 'react';
// import Select from 'react-select';
// import { useTranslation } from 'react-i18next';
// import { useNavigate } from 'react-router-dom';

// import Loading from '@components/Shared/Loader/Loading';
// import { Card, CardFooter, CardHeader } from '@components/card/card';

// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { initReport, getReportPagedData, selectReport, setReportRequest } from '@store/DynamicSlice/reportTableSlice';

// import ReportExportExcelModal, { type ExportColumn } from '@Helper/ReportPaged/ReportExportExcelModal';
// import ReportPagination from '@Helper/ReportPaged/ReportPagination';

// // import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
// import useGlChartLookups from '@hooks/Finance/ChartAccountsDetails/useGlChartLookups';

// /** =========================
//  * REQUEST SHAPE
//  * ========================= */
// type TaxDeclarationRequestDto = {
//   pageIndex?: number;
//   pageSize?: number;

//   // ✅ modern keys
//   fromDate?: string | null;
//   toDate?: string | null;
//   branchId?: string | null;
//   status?: string | null;
//   taxType?: string | null;
//   suB_TRANS_TYPE?: string | null; // <-- NEW

//   // ✅ legacy keys (to be safe with API)
//   froM_DATE?: string | null;
//   tO_DATE?: string | null;
//   brancH_ID?: string | null;
//   taX_TYPE?: string | null;
// };

// /** =========================
//  * RESPONSE SHAPE (Array items)
//  * ========================= */
// type RowDto = {
//   jE_HEADER_ID: string | null;
//   gL_DATE: string | null;

//   referencE_ID: string | null;
//   code: string | null;
//   suB_CODE: string | null; // <-- NEW
//   suB_TRANS_TYPE: string | null; // <-- NEW

//   taX_TYPE: string | null;

//   name: string | null;
//   namE2: string | null;

//   linE_DESCRIPTION: string | null;
//   brancH_NAME: string | null;

//   b_VAT: number; // <-- NEW (المبلغ الأساسي)
//   suB_VAT_AMOUNT: number; // <-- NEW (مبلغ الضريبة)
//   suB_TOTAL_AMOUNT: number; // <-- NEW (الإجمالي)

//   entereD_DR: number;
//   entereD_CR: number;
//   cumulativE_BALANCE: number;
// };

// const REPORT_KEY = 'RPT_TaxDeclarationStatement';
// const ENDPOINT = 'FinReports/GetTaxDeclarationStatement';

// const safe = (v: any, fallback = '—') => (v === null || v === undefined || v === '' ? fallback : String(v));

// const formatNumber = (num: number | null | undefined, digits: number = 2) => {
//   if (num === null || num === undefined) return '0.00';
//   return new Intl.NumberFormat('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(
//     num || 0
//   );
// };

// const isoOrNull = (d: any) => {
//   if (!d) return null;
//   if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) return `${d}T00:00:00.000Z`;
//   if (d instanceof Date) return d.toISOString();
//   return null;
// };

// const cleanNulls = <T extends Record<string, any>>(obj: T): Partial<T> => {
//   const out: any = {};
//   for (const [k, v] of Object.entries(obj)) {
//     if (v === null || v === undefined || v === '') continue;
//     out[k] = v; // ✅ يحافظ على 0 و false
//   }
//   return out;
// };

// const getOptId = (opt: any): string | null => {
//   const v = opt?.value ?? opt?.id ?? opt?.ID ?? opt?.key ?? null;
//   return v ? String(v) : null;
// };

// const getCodePrefix = (code?: string | null) => {
//   const c = (code ?? '').trim().toUpperCase();
//   if (!c) return null;
//   const m = c.match(/^[A-Z]+/);
//   return m?.[0] ?? null;
// };

// /**
//  * INV: Invoice (AP Invoice)
//  * CASH: Cash Transfer
//  * MOI/MOR/MOV: مخزني
//  */
// const buildDocLink = (code?: string | null, id?: string | null) => {
//   if (!id) return null;
//   const p = getCodePrefix(code);

//   switch (p) {
//     case 'INV':
//       return `/AP/ApInvoices/${id}/UpdateApInvoices`;
//     default:
//       return `/finance/documents/${id}`; // fallback
//   }
// };

// const TaxDeclarationStatement_Paged: React.FC = () => {
//   const { t, i18n } = useTranslation();
//   const isAr = i18n.language !== 'en';

//   const dispatch = useAppDispatch();
//   const navigate = useNavigate();

//   // ===== Branch options
//   const branchHook = useGlChartLookups();
//   const OptionsBranches = branchHook.OptionsBranches;
//   const loadingBranches = branchHook?.loading ?? false;

//   // ===== Filters
//   const [branchFilter, setBranchFilter] = useState<any>(null);
//   const [fromDate, setFromDate] = useState<any>(null);
//   const [toDate, setToDate] = useState<any>(null);

//   const taxTypeOptions = useMemo(
//     () => [
//       { value: null, label: isAr ? 'الكل' : 'All' },
//       { value: 'Purchase', label: isAr ? 'مشتريات' : 'Purchase' },
//       { value: 'Sales', label: isAr ? 'مبيعات' : 'Sales' }
//     ],
//     [isAr]
//   );
//   const [taxType, setTaxType] = useState<any>(taxTypeOptions[0]);

//   const statusOptions = useMemo(
//     () => [
//       { value: null, label: isAr ? 'الكل' : 'All' },
//       { value: 'P', label: isAr ? 'مرحل' : 'Posted' },
//       { value: 'U', label: isAr ? 'غير مرحل' : 'Unposted' }
//     ],
//     [isAr]
//   );
//   const [status, setStatus] = useState<any>(statusOptions[0]);

//   // ===== Transaction Types Options (NEW)
//   const transactionTypesOptions = useMemo(
//     () => [
//       { value: null, label: isAr ? 'الكل' : 'All' },
//       { value: 'DebitMemo', label: isAr ? 'مردود مشتريات' : 'Debit Memo' },
//       { value: 'Bill', label: isAr ? 'فاتورة مشتريات' : 'Bill' }, // أمر شراء
//       { value: 'EXP', label: isAr ? 'مصروفات' : 'Expenses' }, 
//       { value: 'AP_INVOICE', label: isAr ? 'فاتورة مدفوعات' : 'AP Invoice' },  // فاتورة مدفوعات
//       // { value: 'Bill_NonInventory', label: isAr ? 'فاتورة مشتريات (غير مخزنية)' : 'Bill (Non-Inventory)' },
//       // { value: 'Discount', label: isAr ? 'خصم' : 'Discount' },
//       { value: 'DebitMemoSale', label: isAr ? 'مردود مبيعات' : 'Sales Return' },
//       { value: 'Standard', label: isAr ? 'فاتورة مبيعات' : 'Standard Sales' },
//       { value: 'TAX_BANK', label: isAr ? 'رسوم بنك' : 'Bank Tax' },
//       { value: 'AR_TRANS', label: isAr ? 'فاتورة مستحقات' : 'AR Transaction' }
//     ],
//     [isAr]
//   );
//   const [subTransType, setSubTransType] = useState<any>(transactionTypesOptions[0]);

//   const [showExport, setShowExport] = useState(false);

//   // ===== Report state
//   const report = useAppSelector(s => selectReport(s as any, REPORT_KEY));
//   const items = (report?.items ?? []) as RowDto[];
//   const meta = report?.meta ?? null;
//   const loading = report?.loading ?? false;
//   const error = report?.error ?? null;

//   useEffect(() => {
//     const initialRequest: TaxDeclarationRequestDto = {
//       pageIndex: 0,
//       pageSize: 50
//     };

//     dispatch(
//       initReport({
//         reportKey: REPORT_KEY,
//         endpoint: ENDPOINT,
//         initialRequest
//       })
//     );
//   }, [dispatch]);

//   const openDoc = (code?: string | null, id?: string | null) => {
//     const url = buildDocLink(code, id);
//     if (!url) return;
//     navigate(url);
//   };

//   // Helper to get Transaction Type Label
//   const getTransTypeLabel = (val: string | null) => {
//     if (!val) return '—';
//     const match = transactionTypesOptions.find(opt => opt.value === val);
//     return match ? match.label : val;
//   };

//   const applyFilters = () => {
//     const branchId = getOptId(branchFilter);
//     const fd = isoOrNull(fromDate);
//     const td = isoOrNull(toDate);

//     const prevReq = (((report as any)?.request ?? {}) as TaxDeclarationRequestDto) || {};

//     const nextReq: TaxDeclarationRequestDto = {
//       ...prevReq,
//       pageIndex: 0,
//       pageSize: prevReq.pageSize ?? 50,

//       // modern
//       fromDate: fd,
//       toDate: td,
//       branchId,
//       taxType: taxType?.value ?? null,
//       status: status?.value ?? null,
//       suB_TRANS_TYPE: subTransType?.value ?? null, // <-- NEW

//       // legacy duplicates (to be safe)
//       froM_DATE: fd,
//       tO_DATE: td,
//       brancH_ID: branchId,
//       taX_TYPE: taxType?.value ?? null
//     };

//     dispatch(setReportRequest({ reportKey: REPORT_KEY, request: cleanNulls(nextReq) as any }));
//     dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
//   };

//   const clearFilters = () => {
//     setBranchFilter(null);
//     setFromDate(null);
//     setToDate(null);
//     setTaxType(taxTypeOptions[0]);
//     setStatus(statusOptions[0]);
//     setSubTransType(transactionTypesOptions[0]); // <-- NEW

//     const resetReq: TaxDeclarationRequestDto = {
//       pageIndex: 0,
//       pageSize: 50,

//       // modern
//       fromDate: undefined,
//       toDate: undefined,
//       branchId: undefined,
//       taxType: undefined,
//       status: undefined,
//       suB_TRANS_TYPE: undefined, // <-- NEW

//       // legacy duplicates (to be safe)
//       froM_DATE: undefined,
//       tO_DATE: undefined,
//       brancH_ID: undefined,
//       taX_TYPE: undefined
//     };

//     dispatch(setReportRequest({ reportKey: REPORT_KEY, request: resetReq as any }));
//         dispatch(getReportPagedData({ reportKey: REPORT_KEY }));

//   };

//   const TotalsCards = () => {
//     if (!meta) return null;

//     return (
//       <div className='row g-3 mb-4'>
//         <div className='col-lg-3 col-md-6'>
//           <Card className='bg-primary bg-opacity-10 border-0 shadow-sm h-100'>
//             <div className='card-body d-flex align-items-center'>
//               <div className='p-3 me-3'>
//                 <i className='fas fa-scale-balanced text-primary fa-xl'></i>
//               </div>
//               <div>
//                 <h6 className='text-primary fw-bold mb-1'>{isAr ? 'الرصيد الافتتاحي' : 'Opening Balance'}</h6>
//                 <h4 className='mb-0 fw-bold'>{formatNumber(meta.openingBalance)}</h4>
//               </div>
//             </div>
//           </Card>
//         </div>

//         <div className='col-lg-3 col-md-6'>
//           <Card className='bg-success bg-opacity-10 border-0 shadow-sm h-100'>
//             <div className='card-body d-flex align-items-center'>
//               <div className='p-3 me-3'>
//                 <i className='fas fa-arrow-up text-success fa-xl'></i>
//               </div>
//               <div>
//                 <h6 className='text-success fw-bold mb-1'>{isAr ? 'إجمالي ضريبة مدين' : 'Total Tax Debit'}</h6>
//                 <h4 className='mb-0 fw-bold'>{formatNumber(meta.totalTaxDr)}</h4>
//               </div>
//             </div>
//           </Card>
//         </div>

//         <div className='col-lg-3 col-md-6'>
//           <Card className='bg-danger bg-opacity-10 border-0 shadow-sm h-100'>
//             <div className='card-body d-flex align-items-center'>
//               <div className='p-3 me-3'>
//                 <i className='fas fa-arrow-down text-danger fa-xl'></i>
//               </div>
//               <div>
//                 <h6 className='text-danger fw-bold mb-1'>{isAr ? 'إجمالي ضريبة دائن' : 'Total Tax Credit'}</h6>
//                 <h4 className='mb-0 fw-bold'>{formatNumber(meta.totalTaxCr)}</h4>
//               </div>
//             </div>
//           </Card>
//         </div>

//         <div className='col-lg-3 col-md-6'>
//           <Card className='bg-warning bg-opacity-10 border-0 shadow-sm h-100'>
//             <div className='card-body d-flex align-items-center'>
//               <div className='p-3 me-3'>
//                 <i className='fas fa-calculator text-warning fa-xl'></i>
//               </div>
//               <div>
//                 <h6 className='text-warning fw-bold mb-1'>{isAr ? 'صافي الضريبة ' : 'Net Tax Payable'}</h6>
//                 <h4 className='mb-0 fw-bold'>{formatNumber(meta.netTaxPayable)}</h4>
//               </div>
//             </div>
//           </Card>
//         </div>
//       </div>
//     );
//   };

//   const exportColumns: ExportColumn<RowDto>[] = [
//     { headerAr: 'التاريخ', headerEn: 'GL Date', value: r => (r.gL_DATE ? r.gL_DATE.split('T')[0] : '') },
//     { headerAr: 'الفرع', headerEn: 'Branch', value: r => r.brancH_NAME || '' },
//     { headerAr: 'نوع الضريبة', headerEn: 'Tax Type', value: r => r.taX_TYPE || '' },
//     { headerAr: 'نوع الحركة', headerEn: 'Trans Type', value: r => getTransTypeLabel(r.suB_TRANS_TYPE) }, // <-- NEW
//     { headerAr: 'الكود', headerEn: 'Code', value: r => r.suB_CODE || r.code || '' }, // <-- UPDATED
//     { headerAr: 'المبلغ الأساسي', headerEn: 'Base Amount', value: r => r.b_VAT || 0 }, // <-- NEW
//     { headerAr: 'الضريبة', headerEn: 'VAT', value: r => r.suB_VAT_AMOUNT || 0 }, // <-- NEW
//     { headerAr: 'الإجمالي', headerEn: 'Total Amount', value: r => r.suB_TOTAL_AMOUNT || 0 }, // <-- NEW
//     { headerAr: 'مدين', headerEn: 'Debit', value: r => r.entereD_DR || 0 },
//     { headerAr: 'دائن', headerEn: 'Credit', value: r => r.entereD_CR || 0 },
//     { headerAr: 'الرصيد', headerEn: 'Balance', value: r => r.cumulativE_BALANCE || 0 },
//     { headerAr: 'وصف السطر', headerEn: 'Line Desc', value: r => r.linE_DESCRIPTION || '' },
//     { headerAr: 'الوصف', headerEn: 'Description', value: r => (isAr ? r.namE2 || r.name : r.name || r.namE2) || '' }
//   ];

//   return (
//     <>
//       <CardHeader className='mb-3'>
//         <div className='row g-2 align-items-center mb-2'>
//           {/* Branch */}
//           <div className='col-lg-3'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-store text-primary'></i>
//               </span>
//               <Select
//                 isLoading={loadingBranches}
//                 value={branchFilter}
//                 onChange={setBranchFilter}
//                 options={OptionsBranches}
//                 placeholder={isAr ? 'الفرع' : 'Branch'}
//                 isClearable
//                 isSearchable
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>
//           </div>
//  {/* Tax Type (نوع الضريبة) */}
//           <div className='col-lg-2'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold' title={isAr ? 'نوع الضريبة' : 'Tax Type'}>
//                 <i className='fas fa-percent text-info'></i>
//               </span>
//               <Select
//                 value={taxType}
//                 onChange={setTaxType}
//                 options={taxTypeOptions}
//                 placeholder={isAr ? 'نوع الضريبة' : 'Tax Type'}
//                 isSearchable
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>
//           </div>

//           {/* Transaction Type (نوع الحركة) */}
//           <div className='col-lg-2'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold' title={isAr ? 'نوع الحركة' : 'Trans Type'}>
//                 <i className='fas fa-exchange-alt text-success'></i>
//               </span>
//               <Select
//                 value={subTransType}
//                 onChange={setSubTransType}
//                 options={transactionTypesOptions}
//                 placeholder={isAr ? 'نوع الحركة' : 'Trans Type'}
//                 isSearchable
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>
//           </div>

//           {/* Status (الحالة) */}
//           <div className='col-lg-2'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold' title={isAr ? 'الحالة' : 'Status'}>
//                 <i className='fas fa-check-circle text-warning'></i>
//               </span>
//               <Select
//                 value={status}
//                 onChange={setStatus}
//                 options={statusOptions}
//                 placeholder={isAr ? 'الحالة' : 'Status'}
//                 isSearchable
//                 className='flex-grow-1'
//                 classNamePrefix='react-select'
//                 menuPortalTarget={document.body}
//                 styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
//               />
//             </div>
//           </div>

//           {/* Buttons */}
//           <div className='col-lg-3 text-end'>
//             <button
//               className='btn btn-outline-secondary me-2'
//               type='button'
//               onClick={clearFilters}
//               title={t('ClearFilters')}
//             >
//               <i className='fas fa-times fa-fw'></i>
//             </button>

//             <button className='btn btn-theme' type='button' onClick={applyFilters} title={t('ApplyFilters')}>
//               <i className='fas fa-filter fa-fw'></i>
//             </button>
//           </div>
//         </div>

//         <div className='row g-2 align-items-center'>
//           {/* From Date */}
//           <div className='col-lg-3'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-calendar'></i>
//               </span>
//               <input
//                 type='date'
//                 className='form-control'
//                 value={fromDate || ''}
//                 onChange={e => setFromDate(e.target.value)}
//                 placeholder={isAr ? 'من تاريخ' : 'From Date'}
//               />
//             </div>
//           </div>

//           {/* To Date */}
//           <div className='col-lg-3'>
//             <div className='input-group'>
//               <span className='input-group-text fw-bold'>
//                 <i className='fas fa-calendar'></i>
//               </span>
//               <input
//                 type='date'
//                 className='form-control'
//                 value={toDate || ''}
//                 onChange={e => setToDate(e.target.value)}
//                 min={fromDate || undefined}
//                 placeholder={isAr ? 'إلى تاريخ' : 'To Date'}
//               />
//             </div>
//           </div>

//           {/* Export */}
//           <div className='col-lg-6 text-end'>
//             <button
//               className='btn btn-outline-success'
//               type='button'
//               onClick={() => setShowExport(true)}
//               title={t('Export')}
//               disabled={loading || items.length === 0}
//             >
//               <i className='fas fa-file-excel fa-fw'></i>
//             </button>
//           </div>
//         </div>
//       </CardHeader>

//       <TotalsCards />

//       <Card className='mb-4'>
//         <Loading loading={loading} error={error}>
//           <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
//             <table className='table table-hover table-bordered mb-0'>
//               <thead className='sticky-top align-middle' style={{ top: 0, zIndex: 10 }}>
//                 {/* Group header */}
//                 <tr className='bg-theme bg-opacity-35 text-center' style={{ backdropFilter: 'blur(20px)' }}>
//                   <th className='small text-primary' colSpan={7}>
//                     {isAr ? 'تفاصيل البيان' : 'Statement Info'}
//                   </th>
//                   <th className='small text-success' colSpan={6}>
//                     {isAr ? 'المبالغ' : 'Amounts'}
//                   </th>
//                 </tr>

//                 <tr className='bg-theme bg-opacity-25 text-center' style={{ backdropFilter: 'blur(20px)' }}>
//                   {/* Info Columns */}
//                   <th className='small' style={{ minWidth: 105 }}>
//                     {isAr ? 'التاريخ' : 'Date'}
//                   </th>
//                   <th className='small' style={{ minWidth: 140 }}>
//                     {isAr ? 'الفرع' : 'Branch'}
//                   </th>
//                   <th className='small' style={{ minWidth: 100 }}>
//                     {isAr ? 'النوع' : 'Type'}
//                   </th>
//                   <th className='small' style={{ minWidth: 120 }}>
//                     {isAr ? 'نوع الحركة' : 'Trans Type'}
//                   </th>
//                   <th className='small' style={{ minWidth: 130 }}>
//                     {isAr ? 'الكود' : 'Code'}
//                   </th>
//                   {/* <th className='small' style={{ minWidth: 120 }}>
//                     {isAr ? 'وصف السطر' : 'Line Desc'}
//                   </th> */}
//                   <th className='small' style={{ minWidth: 250 }}>
//                     {isAr ? 'الوصف' : 'Description'}
//                   </th>

//                   {/* Amounts Columns */}
//                   <th className='small text-end' style={{ minWidth: 110 }}>
//                     {isAr ? 'المبلغ الأساسي' : 'Base Amt'}
//                   </th>
//                   <th className='small text-end' style={{ minWidth: 110 }}>
//                     {isAr ? 'الضريبة' : 'VAT'}
//                   </th>
//                   <th className='small text-end' style={{ minWidth: 110 }}>
//                     {isAr ? 'الإجمالي' : 'Total'}
//                   </th>
//                   <th className='small text-end' style={{ minWidth: 110 }}>
//                     {isAr ? 'مدين' : 'Debit'}
//                   </th>
//                   <th className='small text-end' style={{ minWidth: 110 }}>
//                     {isAr ? 'دائن' : 'Credit'}
//                   </th>
//                   <th className='small text-end' style={{ minWidth: 130 }}>
//                     {isAr ? 'الرصيد' : 'Balance'}
//                   </th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {!loading && items.length > 0 ? (
//                   items.map((r, idx) => {
//                     const desc = (isAr ? r.namE2 || r.name : r.name || r.namE2) || '';
//                     const isOpening = !r.jE_HEADER_ID && !r.gL_DATE;
//                     const displayCode = r.suB_CODE || r.code; // Fallback for code

//                     return (
//                       <tr
//                         key={`${r.jE_HEADER_ID || 'OB'}-${idx}`}
//                         className={`align-middle ${isOpening ? 'table-light fw-bold' : ''}`}
//                       >
//                         <td className='text-center'>
//                           {r.gL_DATE ? r.gL_DATE.split('T')[0] : isAr ? 'افتتاحي' : 'Opening'}
//                         </td>
//                         <td className='text-start'>{safe(r.brancH_NAME)}</td>
//                         <td className='text-center'>
//                           <span className='badge bg-info bg-opacity-10 border border-info text-info'>
//                             {safe(r.taX_TYPE, isAr ? '—' : '—')}
//                           </span>
//                         </td>
//                         <td className='text-center'>{isOpening ? '—' : getTransTypeLabel(r.suB_TRANS_TYPE)}</td>
//                         <td className='text-center'>
//                           {displayCode && r.referencE_ID ? (
//                             <button
//                               type='button'
//                               className='btn btn-link p-0 fw-bold text-primary text-decoration-none'
//                               onClick={() => openDoc(displayCode, r.referencE_ID)}
//                               title={isAr ? 'فتح المستند' : 'Open document'}
//                             >
//                               {displayCode}
//                             </button>
//                           ) : (
//                             <span className='text-muted'>{safe(displayCode)}</span>
//                           )}
//                         </td>
//                         {/* <td className='text-start'>{safe(r.linE_DESCRIPTION)}</td> */}
//                         <td className='text-start'>
//                           <span className={desc ? '' : 'text-muted fst-italic'}>
//                             {safe(desc, isAr ? 'لا يوجد وصف' : 'No description')}
//                           </span>
//                         </td>

//                         {/* Financial Columns */}
//                         <td className='text-end'>{r.b_VAT ? formatNumber(r.b_VAT) : '—'}</td>
//                         <td className='text-end'>{r.suB_VAT_AMOUNT ? formatNumber(r.suB_VAT_AMOUNT) : '—'}</td>
//                         <td className='text-end'>{r.suB_TOTAL_AMOUNT ? formatNumber(r.suB_TOTAL_AMOUNT) : '—'}</td>

//                         <td className='text-end'>
//                           {r.entereD_DR > 0 ? (
//                             <span className='fw-bold text-success'>{formatNumber(r.entereD_DR)}</span>
//                           ) : (
//                             <span className='text-muted'>—</span>
//                           )}
//                         </td>
//                         <td className='text-end'>
//                           {r.entereD_CR > 0 ? (
//                             <span className='fw-bold text-danger'>{formatNumber(r.entereD_CR)}</span>
//                           ) : (
//                             <span className='text-muted'>—</span>
//                           )}
//                         </td>
//                         <td className='text-end'>
//                           <span className={`fw-bold ${r.cumulativE_BALANCE < 0 ? 'text-danger' : 'text-success'}`}>
//                             {formatNumber(r.cumulativE_BALANCE)}
//                           </span>
//                         </td>
//                       </tr>
//                     );
//                   })
//                 ) : !loading ? (
//                   <tr>
//                     <td colSpan={13} className='text-center py-5'>
//                       <div className='text-muted'>
//                         <i className='fas fa-file-invoice fa-3x mb-3 opacity-50'></i>
//                         <h6>{t('NoData')}</h6>
//                       </div>
//                     </td>
//                   </tr>
//                 ) : null}
//               </tbody>
//             </table>
//           </div>
//         </Loading>

//         <CardFooter>
//           <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
//             <ReportPagination reportKey={REPORT_KEY} maxVisiblePages={3} showItemsPerPage={true} />
//             {!loading && items.length > 0 && (
//               <div className='text-muted small'>
//                 <i className='fas fa-info-circle me-1'></i>
//                 {isAr ? 'عرض' : 'Showing'} {items.length} {isAr ? 'من' : 'of'} {meta?.totalRows || 0}{' '}
//                 {isAr ? 'سجل' : 'records'}
//               </div>
//             )}
//           </div>
//         </CardFooter>
//       </Card>

//       <ReportExportExcelModal
//         show={showExport}
//         onHide={() => setShowExport(false)}
//         reportKey={REPORT_KEY}
//         endpoint={ENDPOINT}
//         columns={exportColumns}
//         exportPageSize={4000}
//         sheetName={({ isAr }) => (isAr ? 'بيان إقرار ضريبي' : 'Tax Declaration Statement')}
//         fileName={({ reportKey }) => `${reportKey}_${new Date().toISOString().slice(0, 10)}.xlsx`}
//       />
//     </>
//   );
// };

// export default TaxDeclarationStatement_Paged;



import React, { useEffect, useMemo, useState } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Loading from '@components/Shared/Loader/Loading';
import { Card, CardFooter, CardHeader } from '@components/card/card';

import { useAppDispatch, useAppSelector } from '@store/hooks';
import { initReport, getReportPagedData, selectReport, setReportRequest } from '@store/DynamicSlice/reportTableSlice';

import ReportExportExcelModal, { type ExportColumn } from '@Helper/ReportPaged/ReportExportExcelModal';
import ReportPagination from '@Helper/ReportPaged/ReportPagination';

import useGlChartLookups from '@hooks/Finance/ChartAccountsDetails/useGlChartLookups';

/** =========================
 * REQUEST SHAPE
 * ========================= */
type TaxDeclarationRequestDto = {
  pageIndex?: number;
  pageSize?: number;

  // ✅ modern keys
  fromDate?: string | null;
  toDate?: string | null;
  branchId?: string | null;
  status?: string | null;
  taxType?: string | null;
  suB_TRANS_TYPE?: string | null; // <-- NEW

  // ✅ legacy keys (to be safe with API)
  froM_DATE?: string | null;
  tO_DATE?: string | null;
  brancH_ID?: string | null;
  taX_TYPE?: string | null;
};

/** =========================
 * RESPONSE SHAPE (Array items)
 * ========================= */
type RowDto = {
  jE_HEADER_ID: string | null;
  gL_DATE: string | null;

  referencE_ID: string | null;
  code: string | null;
  suB_CODE: string | null; // <-- NEW
  suB_TRANS_TYPE: string | null; // <-- NEW

  taX_TYPE: string | null;

  name: string | null;
  namE2: string | null;

  linE_DESCRIPTION: string | null;
  brancH_NAME: string | null;

  b_VAT: number; // <-- NEW (المبلغ الأساسي)
  suB_VAT_AMOUNT: number; // <-- NEW (مبلغ الضريبة)
  suB_TOTAL_AMOUNT: number; // <-- NEW (الإجمالي)

  entereD_DR: number;
  entereD_CR: number;
  cumulativE_BALANCE: number;
};

const REPORT_KEY = 'RPT_TaxDeclarationStatement';
const ENDPOINT = 'FinReports/GetTaxDeclarationStatement';

const safe = (v: any, fallback = '—') => (v === null || v === undefined || v === '' ? fallback : String(v));

const formatNumber = (num: number | null | undefined, digits: number = 2) => {
  if (num === null || num === undefined) return '0.00';
  return new Intl.NumberFormat('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(
    num || 0
  );
};

const isoOrNull = (d: any) => {
  if (!d) return null;
  if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) return `${d}T00:00:00.000Z`;
  if (d instanceof Date) return d.toISOString();
  return null;
};

const cleanNulls = <T extends Record<string, any>>(obj: T): Partial<T> => {
  const out: any = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v === null || v === undefined || v === '') continue;
    out[k] = v; // ✅ يحافظ على 0 و false
  }
  return out;
};

const getOptId = (opt: any): string | null => {
  const v = opt?.value ?? opt?.id ?? opt?.ID ?? opt?.key ?? null;
  return v ? String(v) : null;
};

const getCodePrefix = (code?: string | null) => {
  const c = (code ?? '').trim().toUpperCase();
  if (!c) return null;
  const m = c.match(/^[A-Z]+/);
  return m?.[0] ?? null;
};

/**
 * INV: Invoice (AP Invoice)
 * CASH: Cash Transfer
 * MOI/MOR/MOV: مخزني
 */
const buildDocLink = (code?: string | null, id?: string | null) => {
  if (!id) return null;
  const p = getCodePrefix(code);

  switch (p) {
    case 'INV':
      return `/AP/ApInvoices/${id}/UpdateApInvoices`;
    default:
      return `/finance/documents/${id}`; // fallback
  }
};

const TaxDeclarationStatement_Paged: React.FC = () => {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language !== 'en';

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // ===== Branch options
  const branchHook = useGlChartLookups();
  const OptionsBranches = branchHook.OptionsBranches;
  const loadingBranches = branchHook?.loading ?? false;

  // ===== Filters
  const [branchFilter, setBranchFilter] = useState<any>(null);
  const [fromDate, setFromDate] = useState<any>(null);
  const [toDate, setToDate] = useState<any>(null);

  // ===== Tax Types Options (تم التعديل لمدخلات/مخرجات)
  const taxTypeOptions = useMemo(
    () => [
      { value: null, label: isAr ? 'الكل' : 'All' },
      { value: 'Purchase', label: isAr ? 'مدخلات' : 'Inputs' },
      { value: 'Sales', label: isAr ? 'مخرجات' : 'Outputs' }
    ],
    [isAr]
  );
  const [taxType, setTaxType] = useState<any>(taxTypeOptions[0]);

  // ===== Master List for Transaction Types (القائمة الشاملة)
  const allTransactionTypes = useMemo(
    () => [
      { value: 'DebitMemo', label: isAr ? 'مردود مشتريات' : 'Debit Memo', category: 'Purchase' },
      { value: 'Bill', label: isAr ? 'فاتورة مشتريات' : 'Bill', category: 'Purchase' },
      { value: 'EXP', label: isAr ? 'مصروفات' : 'Expenses', category: 'Purchase' }, 
      { value: 'AP_INVOICE', label: isAr ? 'فاتورة مدفوعات' : 'AP Invoice', category: 'Purchase' },
      { value: 'TAX_BANK', label: isAr ? 'رسوم بنك' : 'Bank Tax', category: 'Purchase' },
      { value: 'DebitMemoSale', label: isAr ? 'مردود مبيعات' : 'Sales Return', category: 'Sales' },
      { value: 'Standard', label: isAr ? 'فاتورة مبيعات' : 'Standard Sales', category: 'Sales' },
      { value: 'AR_TRANS', label: isAr ? 'فاتورة مستحقات' : 'AR Transaction', category: 'Sales' }
    ],
    [isAr]
  );

  // ===== Filtered Transaction Types Options (القائمة المفلترة)
  const transactionTypesOptions = useMemo(() => {
    const filtered = taxType?.value
      ? allTransactionTypes.filter(opt => opt.category === taxType.value)
      : allTransactionTypes;

    return [{ value: null, label: isAr ? 'الكل' : 'All' }, ...filtered];
  }, [isAr, taxType, allTransactionTypes]);

  const [subTransType, setSubTransType] = useState<any>(transactionTypesOptions[0]);

  // تصفير "نوع الحركة" إذا تم تغيير "نوع الضريبة" ولم يعد متوافقاً
  useEffect(() => {
    if (subTransType?.value && taxType?.value) {
      const isValid = allTransactionTypes.find(opt => opt.value === subTransType?.value)?.category === taxType.value;
      if (!isValid) {
        setSubTransType({ value: null, label: isAr ? 'الكل' : 'All' });
      }
    }
  }, [taxType, subTransType, allTransactionTypes, isAr]);

  // ===== Status Options
  const statusOptions = useMemo(
    () => [
      { value: null, label: isAr ? 'الكل' : 'All' },
      { value: 'P', label: isAr ? 'مرحل' : 'Posted' },
      { value: 'U', label: isAr ? 'غير مرحل' : 'Unposted' }
    ],
    [isAr]
  );
  const [status, setStatus] = useState<any>(statusOptions[0]);

  const [showExport, setShowExport] = useState(false);

  // ===== Report state
  const report = useAppSelector(s => selectReport(s as any, REPORT_KEY));
  const items = (report?.items ?? []) as RowDto[];
  const meta = report?.meta ?? null;
  const loading = report?.loading ?? false;
  const error = report?.error ?? null;

  useEffect(() => {
    const initialRequest: TaxDeclarationRequestDto = {
      pageIndex: 0,
      pageSize: 50
    };

    dispatch(
      initReport({
        reportKey: REPORT_KEY,
        endpoint: ENDPOINT,
        initialRequest
      })
    );
  }, [dispatch]);

  const openDoc = (code?: string | null, id?: string | null) => {
    const url = buildDocLink(code, id);
    if (!url) return;
    navigate(url);
  };

  // Helper to get Transaction Type Label (تم التحديث ليقرأ من القائمة الشاملة)
  const getTransTypeLabel = (val: string | null) => {
    if (!val) return '—';
    const match = allTransactionTypes.find(opt => opt.value === val);
    return match ? match.label : val;
  };

  const applyFilters = () => {
    const branchId = getOptId(branchFilter);
    const fd = isoOrNull(fromDate);
    const td = isoOrNull(toDate);

    const prevReq = (((report as any)?.request ?? {}) as TaxDeclarationRequestDto) || {};

    const nextReq: TaxDeclarationRequestDto = {
      ...prevReq,
      pageIndex: 0,
      pageSize: prevReq.pageSize ?? 50,

      // modern
      fromDate: fd,
      toDate: td,
      branchId,
      taxType: taxType?.value ?? null,
      status: status?.value ?? null,
      suB_TRANS_TYPE: subTransType?.value ?? null, // <-- NEW

      // legacy duplicates (to be safe)
      froM_DATE: fd,
      tO_DATE: td,
      brancH_ID: branchId,
      taX_TYPE: taxType?.value ?? null
    };

    dispatch(setReportRequest({ reportKey: REPORT_KEY, request: cleanNulls(nextReq) as any }));
    dispatch(getReportPagedData({ reportKey: REPORT_KEY }));
  };

  const clearFilters = () => {
    setBranchFilter(null);
    setFromDate(null);
    setToDate(null);
    setTaxType(taxTypeOptions[0]);
    setStatus(statusOptions[0]);
    setSubTransType({ value: null, label: isAr ? 'الكل' : 'All' }); // <-- NEW

    const resetReq: TaxDeclarationRequestDto = {
      pageIndex: 0,
      pageSize: 50,

      // modern
      fromDate: undefined,
      toDate: undefined,
      branchId: undefined,
      taxType: undefined,
      status: undefined,
      suB_TRANS_TYPE: undefined, // <-- NEW

      // legacy duplicates (to be safe)
      froM_DATE: undefined,
      tO_DATE: undefined,
      brancH_ID: undefined,
      taX_TYPE: undefined
    };

    dispatch(setReportRequest({ reportKey: REPORT_KEY, request: resetReq as any }));
        dispatch(getReportPagedData({ reportKey: REPORT_KEY }));

  };

  const TotalsCards = () => {
    if (!meta) return null;

    return (
      <div className='row g-3 mb-4'>
        <div className='col-lg-3 col-md-6'>
          <Card className='bg-primary bg-opacity-10 border-0 shadow-sm h-100'>
            <div className='card-body d-flex align-items-center'>
              <div className='p-3 me-3'>
                <i className='fas fa-scale-balanced text-primary fa-xl'></i>
              </div>
              <div>
                <h6 className='text-primary fw-bold mb-1'>{isAr ? 'الرصيد الافتتاحي' : 'Opening Balance'}</h6>
                <h4 className='mb-0 fw-bold'>{formatNumber(meta.openingBalance)}</h4>
              </div>
            </div>
          </Card>
        </div>

        <div className='col-lg-3 col-md-6'>
          <Card className='bg-success bg-opacity-10 border-0 shadow-sm h-100'>
            <div className='card-body d-flex align-items-center'>
              <div className='p-3 me-3'>
                <i className='fas fa-arrow-up text-success fa-xl'></i>
              </div>
              <div>
                <h6 className='text-success fw-bold mb-1'>{isAr ? 'إجمالي ضريبة مدين' : 'Total Tax Debit'}</h6>
                <h4 className='mb-0 fw-bold'>{formatNumber(meta.totalTaxDr)}</h4>
              </div>
            </div>
          </Card>
        </div>

        <div className='col-lg-3 col-md-6'>
          <Card className='bg-danger bg-opacity-10 border-0 shadow-sm h-100'>
            <div className='card-body d-flex align-items-center'>
              <div className='p-3 me-3'>
                <i className='fas fa-arrow-down text-danger fa-xl'></i>
              </div>
              <div>
                <h6 className='text-danger fw-bold mb-1'>{isAr ? 'إجمالي ضريبة دائن' : 'Total Tax Credit'}</h6>
                <h4 className='mb-0 fw-bold'>{formatNumber(meta.totalTaxCr)}</h4>
              </div>
            </div>
          </Card>
        </div>

        <div className='col-lg-3 col-md-6'>
          <Card className='bg-warning bg-opacity-10 border-0 shadow-sm h-100'>
            <div className='card-body d-flex align-items-center'>
              <div className='p-3 me-3'>
                <i className='fas fa-calculator text-warning fa-xl'></i>
              </div>
              <div>
                <h6 className='text-warning fw-bold mb-1'>{isAr ? 'صافي الضريبة ' : 'Net Tax Payable'}</h6>
                <h4 className='mb-0 fw-bold'>{formatNumber(meta.netTaxPayable)}</h4>
              </div>
            </div>
          </Card>
        </div>
      </div>
    );
  };

  const exportColumns: ExportColumn<RowDto>[] = [
    { headerAr: 'التاريخ', headerEn: 'GL Date', value: r => (r.gL_DATE ? r.gL_DATE.split('T')[0] : '') },
    { headerAr: 'الفرع', headerEn: 'Branch', value: r => r.brancH_NAME || '' },
    { headerAr: 'نوع الضريبة', headerEn: 'Tax Type', value: r => r.taX_TYPE || '' },
    { headerAr: 'نوع الحركة', headerEn: 'Trans Type', value: r => getTransTypeLabel(r.suB_TRANS_TYPE) }, // <-- NEW
    { headerAr: 'الكود', headerEn: 'Code', value: r => r.suB_CODE || r.code || '' }, // <-- UPDATED
    { headerAr: 'المبلغ الأساسي', headerEn: 'Base Amount', value: r => r.b_VAT || 0 }, // <-- NEW
    { headerAr: 'الضريبة', headerEn: 'VAT', value: r => r.suB_VAT_AMOUNT || r.entereD_DR || 0 }, // <-- NEW
    { headerAr: 'الإجمالي', headerEn: 'Total Amount', value: r => r.suB_TOTAL_AMOUNT || 0 }, // <-- NEW
    { headerAr: 'مدين', headerEn: 'Debit', value: r => r.entereD_DR || 0 },
    { headerAr: 'دائن', headerEn: 'Credit', value: r => r.entereD_CR || 0 },
    { headerAr: 'الرصيد', headerEn: 'Balance', value: r => r.cumulativE_BALANCE || 0 },
    { headerAr: 'وصف السطر', headerEn: 'Line Desc', value: r => r.linE_DESCRIPTION || '' },
    { headerAr: 'الوصف', headerEn: 'Description', value: r => (isAr ? r.namE2 || r.name : r.name || r.namE2) || '' }
  ];


  console.log(items);
  

  return (
    <>
      <CardHeader className='mb-3'>
        <div className='row g-2 align-items-center mb-2'>
          {/* Branch */}
          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-store text-primary'></i>
              </span>
              <Select
                isLoading={loadingBranches}
                value={branchFilter}
                onChange={setBranchFilter}
                options={OptionsBranches}
                placeholder={isAr ? 'الفرع' : 'Branch'}
                isClearable
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>
 {/* Tax Type (نوع الضريبة) */}
          <div className='col-lg-2'>
            <div className='input-group'>
              <span className='input-group-text fw-bold' title={isAr ? 'نوع الضريبة' : 'Tax Type'}>
                <i className='fas fa-percent text-info'></i>
              </span>
              <Select
                value={taxType}
                onChange={setTaxType}
                options={taxTypeOptions}
                placeholder={isAr ? 'نوع الضريبة' : 'Tax Type'}
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>

          {/* Transaction Type (نوع الحركة) */}
          <div className='col-lg-2'>
            <div className='input-group'>
              <span className='input-group-text fw-bold' title={isAr ? 'نوع الحركة' : 'Trans Type'}>
                <i className='fas fa-exchange-alt text-success'></i>
              </span>
              <Select
                value={subTransType}
                onChange={setSubTransType}
                options={transactionTypesOptions}
                placeholder={isAr ? 'نوع الحركة' : 'Trans Type'}
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>

          {/* Status (الحالة) */}
          <div className='col-lg-2'>
            <div className='input-group'>
              <span className='input-group-text fw-bold' title={isAr ? 'الحالة' : 'Status'}>
                <i className='fas fa-check-circle text-warning'></i>
              </span>
              <Select
                value={status}
                onChange={setStatus}
                options={statusOptions}
                placeholder={isAr ? 'الحالة' : 'Status'}
                isSearchable
                className='flex-grow-1'
                classNamePrefix='react-select'
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>
          </div>

          {/* Buttons */}
          <div className='col-lg-3 text-end'>
            <button
              className='btn btn-outline-secondary me-2'
              type='button'
              onClick={clearFilters}
              title={t('ClearFilters')}
            >
              <i className='fas fa-times fa-fw'></i>
            </button>

            <button className='btn btn-theme' type='button' onClick={applyFilters} title={t('ApplyFilters')}>
              <i className='fas fa-filter fa-fw'></i>
            </button>
          </div>
        </div>

        <div className='row g-2 align-items-center'>
          {/* From Date */}
          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-calendar'></i>
              </span>
              <input
                type='date'
                className='form-control'
                value={fromDate || ''}
                onChange={e => setFromDate(e.target.value)}
                placeholder={isAr ? 'من تاريخ' : 'From Date'}
              />
            </div>
          </div>

          {/* To Date */}
          <div className='col-lg-3'>
            <div className='input-group'>
              <span className='input-group-text fw-bold'>
                <i className='fas fa-calendar'></i>
              </span>
              <input
                type='date'
                className='form-control'
                value={toDate || ''}
                onChange={e => setToDate(e.target.value)}
                min={fromDate || undefined}
                placeholder={isAr ? 'إلى تاريخ' : 'To Date'}
              />
            </div>
          </div>

          {/* Export */}
          <div className='col-lg-6 text-end'>
            <button
              className='btn btn-outline-success'
              type='button'
              onClick={() => setShowExport(true)}
              title={t('Export')}
              disabled={loading || items.length === 0}
            >
              <i className='fas fa-file-excel fa-fw'></i>
            </button>
          </div>
        </div>
      </CardHeader>

      <TotalsCards />

      <Card className='mb-4'>
        <Loading loading={loading} error={error}>
          <div className='table-responsive' style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
            <table className='table table-hover table-bordered mb-0'>
              <thead className='sticky-top align-middle' style={{ top: 0, zIndex: 10 }}>
                {/* Group header */}
                <tr className='bg-theme bg-opacity-35 text-center' style={{ backdropFilter: 'blur(20px)' }}>
                  <th className='small text-primary' colSpan={7}>
                    {isAr ? 'تفاصيل البيان' : 'Statement Info'}
                  </th>
                  <th className='small text-success' colSpan={6}>
                    {isAr ? 'المبالغ' : 'Amounts'}
                  </th>
                </tr>

                <tr className='bg-theme bg-opacity-25 text-center' style={{ backdropFilter: 'blur(20px)' }}>
                  {/* Info Columns */}
                  <th className='small' style={{ minWidth: 105 }}>
                    {isAr ? 'التاريخ' : 'Date'}
                  </th>
                  <th className='small' style={{ minWidth: 140 }}>
                    {isAr ? 'الفرع' : 'Branch'}
                  </th>
                  <th className='small' style={{ minWidth: 100 }}>
                    {isAr ? 'النوع' : 'Type'}
                  </th>
                  <th className='small' style={{ minWidth: 120 }}>
                    {isAr ? 'نوع الحركة' : 'Trans Type'}
                  </th>
                  <th className='small' style={{ minWidth: 130 }}>
                    {isAr ? 'الكود' : 'Code'}
                  </th>
                  {/* <th className='small' style={{ minWidth: 120 }}>
                    {isAr ? 'وصف السطر' : 'Line Desc'}
                  </th> */}
                  <th className='small' style={{ minWidth: 250 }}>
                    {isAr ? 'الوصف' : 'Description'}
                  </th>

                  {/* Amounts Columns */}
                  <th className='small text-end' style={{ minWidth: 110 }}>
                    {isAr ? 'المبلغ الأساسي' : 'Base Amt'}
                  </th>
                  <th className='small text-end' style={{ minWidth: 110 }}>
                    {isAr ? 'الضريبة' : 'VAT'}
                  </th>
                  <th className='small text-end' style={{ minWidth: 110 }}>
                    {isAr ? 'الإجمالي' : 'Total'}
                  </th>
                  <th className='small text-end' style={{ minWidth: 110 }}>
                    {isAr ? 'مدين' : 'Debit'}
                  </th>
                  <th className='small text-end' style={{ minWidth: 110 }}>
                    {isAr ? 'دائن' : 'Credit'}
                  </th>
                  <th className='small text-end' style={{ minWidth: 130 }}>
                    {isAr ? 'الرصيد' : 'Balance'}
                  </th>
                </tr>
              </thead>

              <tbody>
                {!loading && items.length > 0 ? (
                  items.map((r, idx) => {
                    const desc = (isAr ? r.namE2 || r.name : r.name || r.namE2) || '';
                    const isOpening = !r.jE_HEADER_ID && !r.gL_DATE;
                    const displayCode = r.suB_CODE || r.code; // Fallback for code

                    return (
                      <tr
                        key={`${r.jE_HEADER_ID || 'OB'}-${idx}`}
                        className={`align-middle ${isOpening ? 'table-light fw-bold' : ''}`}
                      >
                        <td className='text-center'>
                          {r.gL_DATE ? r.gL_DATE.split('T')[0] : isAr ? 'افتتاحي' : 'Opening'}
                        </td>
                        <td className='text-start'>{safe(r.brancH_NAME)}</td>
                        <td className='text-center'>
                          <span className='badge bg-info bg-opacity-10 border border-info text-info'>
                            {safe(r.taX_TYPE, isAr ? '—' : '—')}
                          </span>
                        </td>
                        <td className='text-center'>{isOpening ? '—' : getTransTypeLabel(r.suB_TRANS_TYPE)}</td>
                        <td className='text-center'>
                          {displayCode && r.referencE_ID ? (
                            <button
                              type='button'
                              className='btn btn-link p-0 fw-bold text-primary text-decoration-none'
                              onClick={() => openDoc(displayCode, r.referencE_ID)}
                              title={isAr ? 'فتح المستند' : 'Open document'}
                            >
                              {displayCode}
                            </button>
                          ) : (
                            <span className='text-muted'>{safe(displayCode)}</span>
                          )}
                        </td>
                        {/* <td className='text-start'>{safe(r.linE_DESCRIPTION)}</td> */}
                        <td className='text-start'>
                          <span className={desc ? '' : 'text-muted fst-italic'}>
                            {safe(desc, isAr ? 'لا يوجد وصف' : 'No description')}
                          </span>
                        </td>

                        {/* Financial Columns */}
                        <td className='text-end'>{r.b_VAT ? formatNumber(r.b_VAT) : '—'}</td>
                        <td className='text-end'>{r.suB_VAT_AMOUNT ? formatNumber(r.suB_VAT_AMOUNT) : '—'}</td>
                        <td className='text-end'>{r.suB_TOTAL_AMOUNT ? formatNumber(r.suB_TOTAL_AMOUNT) : '—'}</td>

                        <td className='text-end'>
                          {r.entereD_DR > 0 ? (
                            <span className='fw-bold text-success'>{formatNumber(r.entereD_DR)}</span>
                          ) : (
                            <span className='text-muted'>—</span>
                          )}
                        </td>
                        <td className='text-end'>
                          {r.entereD_CR > 0 ? (
                            <span className='fw-bold text-danger'>{formatNumber(r.entereD_CR)}</span>
                          ) : (
                            <span className='text-muted'>—</span>
                          )}
                        </td>
                        <td className='text-end'>
                          <span className={`fw-bold ${r.cumulativE_BALANCE < 0 ? 'text-danger' : 'text-success'}`}>
                            {formatNumber(r.cumulativE_BALANCE)}
                          </span>
                        </td>
                      </tr>
                    );
                  })
                ) : !loading ? (
                  <tr>
                    <td colSpan={13} className='text-center py-5'>
                      <div className='text-muted'>
                        <i className='fas fa-file-invoice fa-3x mb-3 opacity-50'></i>
                        <h6>{t('NoData')}</h6>
                      </div>
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        </Loading>

        <CardFooter>
          <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
            <ReportPagination reportKey={REPORT_KEY} maxVisiblePages={3} showItemsPerPage={true} />
          
          </div>
        </CardFooter>
      </Card>

      <ReportExportExcelModal
        show={showExport}
        onHide={() => setShowExport(false)}
        reportKey={REPORT_KEY}
        endpoint={ENDPOINT}
        columns={exportColumns}
        exportPageSize={4000}
        sheetName={({ isAr }) => (isAr ? 'بيان إقرار ضريبي' : 'Tax Declaration Statement')}
        fileName={({ reportKey }) => `${reportKey}_${new Date().toISOString().slice(0, 10)}.xlsx`}
      />
    </>
  );
};

export default TaxDeclarationStatement_Paged;